import { styled } from '@mui/material';
import Text from '@components/Text';
import { VOICE_LOUDNESS_COLORS } from './colors';

export const ConfigLayout = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  flexWrap: 'wrap',
  gap: 32,
  marginTop: 18,
  marginInlineStart: 32,
});

export const Fields = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 14,
});

export const Field = styled('label')({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
});

export const RangeTableTitle = styled(Text)({
  display: 'block',
  marginBottom: 6,
});

export const RangeTable = styled('table')(
  {
    borderCollapse: 'collapse',
    minWidth: 190,
    fontSize: 12,
    '& th, & td': {
      padding: '3px 10px',
      textAlign: 'center',
      border: '1px solid',
    },
    '& .targetRange td': {
      fontWeight: 600,
      backgroundColor: `${VOICE_LOUDNESS_COLORS.TARGET}24`,
    },
  },
  ({ theme }) => ({
    color: theme.palette.novotalk.$textColor,
    '& th, & td': {
      borderColor: theme.palette.novotalk.$borderColorLight,
    },
    '& th': {
      backgroundColor: theme.palette.novotalk.$backgroundColorLight,
    },
    '& .targetRange td:first-of-type': {
      boxShadow: `inset ${theme.RTL ? -4 : 4}px 0 0 ${VOICE_LOUDNESS_COLORS.TARGET}`,
    },
  }),
);